import { render } from "./HistorialView.vue?vue&type=template&id=ed46072a&scoped=true"
import script from "./HistorialView.vue?vue&type=script&lang=js"
export * from "./HistorialView.vue?vue&type=script&lang=js"

import "./HistorialView.vue?vue&type=style&index=0&id=ed46072a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed46072a"]])

export default __exports__